import script from "./ChangeUserData.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeUserData.vue?vue&type=script&setup=true&lang=js"

import "./ChangeUserData.vue?vue&type=style&index=0&id=1994117e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1994117e"]])

export default __exports__